import './inputList.css';

export default function InputList({ id, labelText, inputArr, selectedValue, changeHandler, disableVal }) {
    const listItemClickHandler = (e, val) => {
        e.preventDefault();

        if (disableVal)
            return false;

        changeHandler(e, val);
    }

    return (
        <div id={id + "Input"} className="form-input-container">
            <label className="form-label" htmlFor={"list-" + id + "Input"}>{labelText} </label>
            <div className="form-list-container">
                <input
                    className="form-item form-input"
                    id={"list-" + id + "Input"}
                    type="hidden"
                    value={selectedValue}
                    size="30"
                    maxLength="128"
                    onChange={changeHandler}
                    disabled={disableVal}
                ></input>

                <div className="list-item">
                    <a href="#" disabled={disableVal} className={'' === selectedValue ? 'active' : null} onClick={e => listItemClickHandler(e, '')}>Show All</a>
                </div>
                {inputArr.map(input => (
                    <div key={input.id} className="list-item">
                        <a href="#" disabled={disableVal} className={input.id === selectedValue ? 'active' : null} onClick={e => listItemClickHandler(e, input.id)}>{input.name}</a>
                    </div>
                ))}
            </div>
        </div>
    );
}